// Разметка печатных бланков по документам 1С: УПД (ПП РФ № 1137), договор-счёт, КП.
//
// ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ, А НЕ HTML ВНУТРИ print1c.ts. Ровно за тем же, зачем blanks73.ts
// отделён от print73.ts: бланк — это ДАННЫЕ. Пока список граф лежит массивом, его можно
// пересчитать («по скольким графам из шестнадцати у нас нет ни одной отметки»), сверить с
// постановлением по кодам и напечатать в служебной отметке. Пока он размазан по шаблонной
// строке, сделать этого нельзя — и лист молча выходит с пустыми клетками.
//
// ОТКУДА СНЯТА РАЗМЕТКА. Официальная форма УПД — peleng-portal/src/worker.js:3890–4107
// (`updOfficialForm`), упрощённая — там же 3823–3866 (`updPrintHTML`), договор-счёт —
// 10897–11033 (`sdDocHtml`), коммерческое предложение — 10919–10967 (`kpDocHtml`).
// Читали, не меняли: портал трогать нельзя.
//
// ЧЕМ НАША КОПИЯ ОТЛИЧАЕТСЯ ОТ ОРИГИНАЛА НА ПОРТАЛЕ, И ПОЧЕМУ.
//   • Портал подставляет ФИО подписантов константами («Ильин А. П.», «Ершова Е. Г.») даже
//     когда в документе их нет. У нас источника ФИО нет вовсе (см. ПОЧЕМУ_НЕТ_ПОДПИСАНТОВ),
//     поэтому в графах [10], [13] и в шапке остаётся линейка под подпись — как на бумажном
//     бланке — и оговорка внизу листа. Напечатать чужую фамилию там, где данных нет,
//     нельзя: под этим ФИО документ уйдёт в налоговую.
//   • Портал печатает факсимиле и печать по чекбоксу (`.sig`, `.stamp`). Картинок у нас нет
//     и заводить их в CRM никто не разрешал — блок подписи пустой.

/**
 * Реквизиты продавца. ВБИТЫ КОНСТАНТАМИ, и это осознанно.
 *
 * ПОЧЕМУ НЕ ИЗ ДАННЫХ. В зеркале (`ut_sales`) от организации есть только ссылка `org_ref`:
 * ни наименования, ни ИНН, ни адреса, ни банковского счёта там нет — справочник организаций
 * 1С не зеркалится вовсе. Достать их можно только живым запросом в 1С через прокси ядра
 * (`Catalog_Организации` + `Catalog_БанковскиеСчета` + `Catalog_Банки`), то есть тремя
 * запросами на каждый лист, и лист перестанет печататься, когда 1С молчит. Реквизиты
 * юрлица меняются раз в несколько лет — цена такой зависимости несоразмерна.
 *
 * ОТКУДА ВЗЯТЫ ЗНАЧЕНИЯ (сверено 28.07.2026, всё сходится между тремя источниками):
 *   • наименование, ИНН, КПП   — peleng-portal/src/worker.js:3733 (`UPD_SELLER`) и 3870–3871
 *                                (`UPD_SELLER_FULL`, `UPD_SELLER_ADDR`);
 *   • банк, БИК, к/с, р/с      — peleng-portal/src/worker.js:11010–11013 (шапка договора-счёта);
 *   • ОГРН, юр. адрес, телефон — брифинг/contract-create.html:126–136 (константа `SIR`) и
 *                                живой ответ 1С `GET /1c/bp/Catalog_Организации`
 *                                (`НаименованиеПолное`, `ОГРН`, `КонтактнаяИнформация[0]`).
 *
 * РАСХОЖДЕНИЕ, О КОТОРОМ НАДО ЗНАТЬ. У одного и того же юрлица КПП в двух базах 1С разный:
 * в БП — 783801001, в УТ — 780101001. Здесь стоит версия БП: именно из БП печатает УПД
 * портал 55, и именно она стоит в счетах. Все реализации в нашем зеркале при этом ссылаются
 * на организацию УТ. Это расхождение В ИСТОЧНИКЕ — правит его владелец 1С, не мы; наше дело
 * сказать о нём на листе (см. `КПП_РАСХОЖДЕНИЕ`).
 */
export const ПРОДАВЕЦ = {
  краткое: 'ООО «Связь и Радионавигация СПб»',
  полное: 'Общество с ограниченной ответственностью "Связь и Радионавигация СПб"',
  инн: '7826155530',
  кпп: '783801001',
  огрн: '1027810273952',
  адрес: '198035, Город Санкт-Петербург, вн.тер.г. муниципальный округ Екатерингофский,'
    + ' ул Степана Разина, д. 9, литера Е, помещ. 33-Н',
  телефон: '+7 (812) 467-36-73',
  почта: 'sales@cirspb.ru',
  сайт: 'https://cirspb.ru',
  банк: 'АО "ТБанк" г. Москва',
  бик: '044525974',
  корсчёт: '30101810145250000974',
  расчётный: '40702810210000832611',
} as const

/** Печатается на листе, когда документ ссылается на организацию из УТ. */
export const КПП_РАСХОЖДЕНИЕ = 'КПП продавца взят из констант CRM по базе БП (783801001).'
  + ' В базе УТ у того же ИНН записан КПП 780101001. Расхождение в источнике —'
  + ' перед подписью сверьтесь с 1С.'

/** Почему графы подписантов пусты. Печатается оговоркой, а не додумывается фамилией. */
export const ПОЧЕМУ_НЕТ_ПОДПИСАНТОВ = 'ФИО руководителя и главного бухгалтера в зеркале не'
  + ' хранятся, а регистр 1С «ОтветственныеЛицаОрганизаций» прокси ядра не выпускает'
  + ' (регистров сведений нет в белом списке ODATA_ENTITIES). Линейки под подпись оставлены'
  + ' пустыми намеренно: подставить фамилию, которой нет в данных, нельзя.'

/** Дата, когда разметка снята с портала 55. Печатается на листе. */
export const БЛАНКИ_1С_СНЯТЫ = '28.07.2026'

/** Названия месяцев для «12 июля 2026 г.» в графе (1). */
export const МЕСЯЦЫ = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
] as const

/**
 * Ставки НДС, как их пишет 1С, в проценты. `null` — «налога нет» (это ЗНАЧЕНИЕ, а не
 * незнание): «без НДС» на бланке печатается словами, и это законная отметка.
 *
 * Всё, чего в этой таблице нет, — незнание: незнакомая строка ставки даёт прочерк и попадает
 * в оговорку. Молча считать её нулём нельзя: НДС 22 %, введённый в 2026 году, в старом коде
 * порталов как раз и превращался в ноль (`INV_VAT_PCT` в worker.js:3382 знает только четыре
 * ставки), и лист выходил с заниженным налогом.
 */
export const СТАВКИ_НДС: Record<string, number | null> = {
  'НДС22': 22,
  'НДС20': 20,
  'НДС20_120': 20,
  'НДС18': 18,
  'НДС10': 10,
  'НДС10_110': 10,
  'НДС5': 5,
  'НДС7': 7,
  'НДС0': 0,
  'БезНДС': null,
  'НДСНеОблагается': null,
}

/**
 * Ключи полей строки документа, которыми питаются графы таблицы УПД.
 *
 * `ценаПредложения` и `суммаПредложения` — не графы бланка 1137, а колонки коммерческого
 * предложения, и стоят они особняком нарочно. В бланке 1137 «Цена» (графа 4) обязана быть
 * ценой БЕЗ налога, а «Стоимость» (графа 9) — С налогом: так требует постановление, и
 * поэтому цена × количество в бланке итогу строки не равны. В коммерческом предложении так
 * нельзя: клиент читает строку глазами и умножает. Портал 55 в `kpDocHtml` печатает цену и
 * сумму В ОДНОМ БАЗИСЕ — том, в котором предложение выставлено (worker.js:10938), — и мы
 * повторяем это. Отдельные ключи, а не переиспользование `цена`/`всего`, — чтобы бланк 1137
 * нельзя было случайно перевести на «удобные» колонки.
 */
export type КлючГрафы =
  | 'код' | 'номер' | 'наименование' | 'кодВида' | 'едКод' | 'едИмя' | 'количество'
  | 'цена' | 'база' | 'акциз' | 'ставка' | 'ндс' | 'всего' | 'странаКод' | 'страна' | 'гтд'
  | 'ценаПредложения' | 'суммаПредложения'

export interface ГрафаУПД {
  /** Код графы по постановлению: печатается отдельной строкой под шапкой таблицы. */
  код: string
  /** Заголовок графы. `&shy;` — мягкие переносы, иначе колонка в 2,3 % не влезает. */
  титул: string
  /** Ширина в процентах листа A4 landscape. Взяты из colgroup формы портала 55. */
  ширина: number
  /** Откуда берём значение. Печатается в оговорке, когда графа пустая. */
  из: string
  /** Поле строки. `null` — графа заполняется самим листом (номер по порядку, «без акциза»). */
  поле: КлючГрафы | null
  /** Как выравнивать: числа вправо, наименование влево, остальное по центру. */
  вид?: 'ч' | 'л'
}

/**
 * Шестнадцать граф таблицы УПД. Порядок и коды — приложение № 1 к постановлению
 * Правительства РФ от 26.12.2011 № 1137 (в редакции ПП РФ от 23.01.2026 № 26).
 */
export const ГРАФЫ_УПД: ГрафаУПД[] = [
  {
    код: 'А', ширина: 7.52, поле: 'код', титул: 'Код товара/ работ, услуг',
    из: 'Catalog_Номенклатура.Code по Номенклатура_Key строки',
  },
  {
    код: '1', ширина: 2.55, поле: null, титул: '№ п/п',
    из: 'порядковый номер строки на листе',
  },
  {
    код: '1а', ширина: 14.09, поле: 'наименование', вид: 'л',
    титул: 'Наименование товара (описание выполненных работ, оказанных услуг), имущественного права',
    из: 'Содержание строки, иначе Catalog_Номенклатура.Description',
  },
  {
    код: '1б', ширина: 5.03, поле: 'кодВида', титул: 'Код вида товара',
    из: 'код ТН ВЭД ЕАЭС — только для вывоза в ЕАЭС; в наших документах не заполняется',
  },
  {
    код: '2', ширина: 2.29, поле: 'едКод', титул: 'код',
    из: 'Catalog_КлассификаторЕдиницИзмерения.Code (ОКЕИ) по ЕдиницаИзмерения_Key',
  },
  {
    код: '2а', ширина: 4.99, поле: 'едИмя', титул: 'условное обозна&shy;чение (нацио&shy;нальное)',
    из: 'Catalog_КлассификаторЕдиницИзмерения.Description',
  },
  {
    код: '3', ширина: 5.14, поле: 'количество', вид: 'ч', титул: 'Коли-чество (объем)',
    из: 'Количество строки документа',
  },
  {
    код: '4', ширина: 7.20, поле: 'цена', вид: 'ч', титул: 'Цена (тариф) за единицу измерения',
    из: 'стоимость без налога ÷ количество (не поле Цена: она бывает с налогом)',
  },
  {
    код: '5', ширина: 8.03, поле: 'база', вид: 'ч',
    титул: 'Стоимость товаров (работ, услуг), имущест&shy;венных прав без налога - всего',
    из: 'Сумма строки за вычетом СуммаНДС, если сумма включает налог',
  },
  {
    код: '6', ширина: 3.73, поле: 'акциз', титул: 'В том числе сумма акциза',
    из: 'подакцизных товаров не продаём — печатается «без акциза»',
  },
  {
    код: '7', ширина: 5.60, поле: 'ставка', титул: 'Налоговая ставка',
    из: 'СтавкаНДС строки документа',
  },
  {
    код: '8', ширина: 6.58, поле: 'ндс', вид: 'ч', титул: 'Сумма налога, предъяв&shy;ляемая покупателю',
    из: 'СуммаНДС строки документа',
  },
  {
    код: '9', ширина: 7.94, поле: 'всего', вид: 'ч',
    титул: 'Стоимость товаров (работ, услуг), имущест&shy;венных прав с налогом - всего',
    из: 'стоимость без налога + сумма налога',
  },
  {
    код: '10', ширина: 2.90, поле: 'странаКод', титул: 'циф&shy;ро&shy;вой код',
    из: 'Catalog_СтраныМира.Code по СтранаПроисхождения_Key',
  },
  {
    код: '10а', ширина: 6.49, поле: 'страна', титул: 'краткое наимено&shy;вание',
    из: 'Catalog_СтраныМира.Description',
  },
  {
    код: '11', ширина: 9.92, поле: 'гтд',
    титул: 'Регистрационный номер декларации на товары или регистрационный номер партии товара,'
      + ' подлежащего прослеживаемости',
    из: 'Catalog_НомераГТД.Code по НомерГТД_Key',
  },
]

/** Пояснение к статусу УПД в левом поле бланка. Статус 1 — счёт-фактура и передаточный документ. */
export const СТАТУС_УПД = {
  значение: '1',
  расшифровка: '1 – счет-фактура и передаточный документ (акт)<br>2 – передаточный документ (акт)',
  приложение: 'Приложение № 1 к постановлению Правительства Российской Федерации от 26 декабря 2011 г.'
    + ' № 1137<br>(в редакции постановления Правительства Российской Федерации от 23 января 2026 г. № 26)',
} as const

/** Поле шапки или подвала бланка: код в скобках/квадратных скобках и что туда идёт. */
export interface ПолеБланка {
  код: string
  титул: string
  из: string
}

/**
 * Поля шапки УПД. Коды в круглых скобках — из счёта-фактуры, в квадратных — из
 * передаточного документа. Считаются так же, как графы таблицы: пустое поле попадает
 * в оговорку под именем своего кода, а не пропадает.
 */
export const ПОЛЯ_ШАПКИ_УПД: ПолеБланка[] = [
  { код: '(1)', титул: 'Счет-фактура № и дата', из: 'Number и Date документа' },
  { код: '(1а)', титул: 'Исправление № и дата', из: 'исправлений не делаем — прочерк' },
  { код: '(2)', титул: 'Продавец', из: 'константы CRM (см. ПРОДАВЕЦ)' },
  { код: '(2а)', титул: 'Адрес продавца', из: 'константы CRM' },
  { код: '(2б)', титул: 'ИНН/КПП продавца', из: 'константы CRM' },
  { код: '(3)', титул: 'Грузоотправитель и его адрес', из: 'продавец — печатается «он же»' },
  { код: '(4)', титул: 'Грузополучатель и его адрес', из: 'Грузополучатель_Key, иначе АдресДоставки, иначе покупатель' },
  { код: '(5)', титул: 'К платежно-расчетному документу', из: 'платёжки в зеркале нет' },
  { код: '(5а)', титул: 'Документ об отгрузке', из: 'номер и дата самого УПД' },
  { код: '(5б)', титул: 'К счету-фактуре на аванс', из: 'авансовых СФ не подтягиваем' },
  { код: '(6)', титул: 'Покупатель', из: 'Catalog_Контрагенты.НаименованиеПолное по Контрагент_Key' },
  { код: '(6а)', титул: 'Адрес покупателя', из: 'Catalog_Контрагенты.КонтактнаяИнформация' },
  { код: '(6б)', титул: 'ИНН/КПП покупателя', из: 'Catalog_Контрагенты.ИНН и .КПП' },
  { код: '(7)', титул: 'Валюта: наименование, код', из: 'ВалютаДокумента_Key; рубль — 643' },
  { код: '(8)', титул: 'Идентификатор государственного контракта', из: 'в документах не заполняется' },
]

/** Поля передаточной части УПД: те самые [8]–[19]. */
export const ПОЛЯ_ПЕРЕДАЧИ_УПД: ПолеБланка[] = [
  { код: '[8]', титул: 'Основание передачи (сдачи) / получения (приемки)', из: 'ОснованиеПередачи, иначе Catalog_ДоговорыКонтрагентов' },
  { код: '[9]', титул: 'Данные о транспортировке и грузе', из: 'транспортных документов в 1С не ведём' },
  { код: '[10]', титул: 'Товар (груз) передал / услуги сдал', из: 'ФИО подписанта — источника нет' },
  { код: '[11]', титул: 'Дата отгрузки, передачи (сдачи)', из: 'Date документа' },
  { код: '[12]', титул: 'Иные сведения об отгрузке, передаче', из: 'поля нет' },
  { код: '[13]', титул: 'Ответственный за правильность оформления', из: 'ФИО подписанта — источника нет' },
  { код: '[14]', титул: 'Наименование экономического субъекта — составителя', из: 'константы CRM' },
  { код: '[15]', титул: 'Товар (груз) получил / услуги принял', из: 'заполняет покупатель от руки' },
  { код: '[16]', титул: 'Дата получения (приемки)', из: 'заполняет покупатель от руки' },
  { код: '[17]', титул: 'Иные сведения о получении, приемке', из: 'заполняет покупатель от руки' },
  { код: '[18]', титул: 'Ответственный со стороны покупателя', из: 'заполняет покупатель от руки' },
  { код: '[19]', титул: 'Наименование субъекта — составителя (покупатель)', из: 'Catalog_Контрагенты покупателя' },
]

/** Колонка упрощённого листа: девять граф вместо шестнадцати. */
export interface КолонкаПростая {
  титул: string
  поле: КлючГрафы | null
  вид?: 'ч' | 'л'
  ширина?: string
}

/**
 * Упрощённый лист (аналог `updPrintHTML`, worker.js:3823). Это НЕ бланк 1137 и на листе
 * так и написано: девять колонок, ни страны, ни ГТД, ни ОКЕИ. Нужен там, где строк
 * документа нет в 1С, а показать состав всё-таки надо.
 */
export const КОЛОНКИ_ПРОСТЫЕ: КолонкаПростая[] = [
  { титул: '№', поле: null, ширина: '30px' },
  { титул: 'Наименование', поле: 'наименование', вид: 'л' },
  { титул: 'Ед.', поле: 'едИмя', ширина: '46px' },
  { титул: 'Кол-во', поле: 'количество', вид: 'ч', ширина: '68px' },
  { титул: 'Цена без НДС', поле: 'цена', вид: 'ч', ширина: '86px' },
  { титул: 'Стоимость без НДС', поле: 'база', вид: 'ч', ширина: '96px' },
  { титул: 'Ставка', поле: 'ставка', ширина: '62px' },
  { титул: 'Сумма НДС', поле: 'ндс', вид: 'ч', ширина: '86px' },
  { титул: 'Всего с НДС', поле: 'всего', вид: 'ч', ширина: '96px' },
]

/**
 * Колонки договора-счёта. Разметка из `sdDocHtml` (worker.js:11024), но заголовки колонок
 * «Цена» и «Сумма» уточнены до «Цена без НДС» и «Сумма с НДС».
 *
 * ПОЧЕМУ УТОЧНЕНЫ. Под этими колонками у нас стоят графы бланка: `цена` — это стоимость
 * без налога, делённая на количество, а `всего` — стоимость С налогом. Значит цена ×
 * количество ≠ сумма, и колонка, подписанная просто «Цена», читается как ошибка счёта.
 * Подпись — единственное, что тут можно исправить: сами числа верны, и переводить счёт на
 * «цену как в документе» нельзя, у 1С она бывает и с налогом, и без — по флагу документа.
 */
export const КОЛОНКИ_СЧЁТА: КолонкаПростая[] = [
  { титул: '№', поле: null, ширина: '26px' },
  { титул: 'Товары (работы, услуги)', поле: 'наименование', вид: 'л' },
  { титул: 'Кол-во', поле: 'количество', вид: 'ч', ширина: '54px' },
  { титул: 'Ед.', поле: 'едИмя', ширина: '40px' },
  { титул: 'Цена без НДС', поле: 'цена', вид: 'ч', ширина: '84px' },
  { титул: 'Сумма НДС', поле: 'ндс', вид: 'ч', ширина: '84px' },
  { титул: 'Сумма с НДС', поле: 'всего', вид: 'ч', ширина: '90px' },
]

/**
 * Колонки коммерческого предложения. Копия шапки из `kpDocHtml` (worker.js:10952),
 * включая базис колонок: «Цена» и «Сумма» — в том виде, в котором предложение выставлено.
 *
 * Здесь, в отличие от счёта, взяты `ценаПредложения` и `суммаПредложения`, а не графы
 * бланка: КП — не налоговый документ, его читают глазами и умножают цену на количество.
 * Ставка НДС стоит отдельной колонкой ровно затем, чтобы базис был назван (см. `КлючГрафы`).
 */
export const КОЛОНКИ_КП: КолонкаПростая[] = [
  { титул: '№', поле: null, ширина: '26px' },
  { титул: 'Товары (работы, услуги)', поле: 'наименование', вид: 'л' },
  { титул: 'Кол-во', поле: 'количество', вид: 'ч', ширина: '54px' },
  { титул: 'Ед.', поле: 'едИмя', ширина: '40px' },
  { титул: 'Цена', поле: 'ценаПредложения', вид: 'ч', ширина: '84px' },
  { титул: 'Ставка НДС', поле: 'ставка', ширина: '62px' },
  { титул: 'Сумма', поле: 'суммаПредложения', вид: 'ч', ширина: '90px' },
]

/**
 * Пять пунктов оферты договора-счёта. Дословно из `sdDocHtml` (worker.js:11015–11019):
 * это юридический текст, и «своими словами» его переписывать нельзя.
 */
export const ПУНКТЫ_ДОГОВОРА_СЧЁТА: string[] = [
  'Настоящий Договор-счёт одновременно является офертой, в соответствии со ст. 435 ГК РФ,'
  + ' договором поставки комплекта судового оборудования и/или сменно-запасных частей с'
  + ' одновременной передачей технической документации по их использованию (при условии наличия'
  + ' таковой), а также договором подряда по техническому обслуживанию, ремонту и/или замене'
  + ' судового оборудования.',
  'Поставщик обязуется поставить оборудование/выполнить работы/оказать услуги по ценам, в порядке'
  + ' и в сроки, указанные в настоящем Договоре-счёте, при условии зачисления денежных средств в'
  + ' размере 100% стоимости (может меняться) по настоящему Договору-счёту на расчетный счет'
  + ' Поставщика в течение 3 (трёх) банковских дней (может меняться) с даты выставления настоящего'
  + ' Договора-счёта. В случае непоступления денежных средств в указанный срок или поступления в'
  + ' недостаточном размере, поставка Оборудования/выполнение работ/оказание услуг не подлежат'
  + ' осуществлению, а денежные средства подлежат возврату Заказчику по его письменному заявлению.',
  'С гарантийными обязательствами Поставщика/Исполнителя можно ознакомиться на сайте'
  + ' https://cirspb.ru/about/guaranty/.',
  'Оплата Покупателем/Заказчиком Договора-счёта в сроки и в размере, предусмотренные п. 2'
  + ' настоящего Договора-счёта, означает безусловное согласие с его условиями, а также условиями'
  + ' публичной оферты, размещенной на сайте https://cirspb.ru/about/oferta/.',
  'Выборка товара со склада Поставщика в г. Санкт-Петербурге осуществляется силами и средствами'
  + ' Покупателя. Срок готовности товара к отгрузке составляет до 3 (трёх) рабочих дней.'
  + ' (может меняться)',
]

/** Блок про сверхурочные в договоре-счёте. Тоже дословно (worker.js:11021–11023). */
export const БЛОК_РАБОТ_ДОГОВОРА_СЧЁТА: string[] = [
  'Время работы инженеров: будние дни с 9:00 до 18:00 часов, при выполнении работ в сверхурочное'
  + ' время (Понедельник – Пятница с 18:00 до 24:00) применяется коэффициент x1.5. При выполнении'
  + ' работ в сверхурочное время (Понедельник – Пятница с 00:00 до 09:00, Суббота, Воскресенье и'
  + ' праздники) применяется коэффициент x2.0.',
  'В Договоре-счёте указана Предварительная стоимость выполнения работ. Окончательная стоимость'
  + ' работ подлежит определению по окончание выполнения работ с установлением тарифа работы'
  + ' 1 инженера за 1 час.',
  'Сварочные и такелажные работы, изготовление металлоконструкций в стоимость не входят. Пропуска'
  + ' и техническое наблюдение оформляются за счет Заказчика.',
]

/** Две формулировки оферты в КП. Из `kpDocHtml` (worker.js:10945). */
export const ОФЕРТА_КП = {
  оферта: 'Настоящий документ является ОФЕРТОЙ и основанием для оплаты, т.е. письменным'
    + ' предложением заключить договор (ст. 435 ГК РФ). Оплата или подписание данного документа'
    + ' является АКЦЕПТОМ (ст. 438 п. 3 ГК РФ) и означает заключение договора в письменной форме'
    + ' (ст. 434 п. 3 ГК РФ). Уведомление об оплате обязательно!!!',
  не_оферта: 'Настоящий документ НЕ является ОФЕРТОЙ и основанием для оплаты.',
} as const
